<template>
  <component
    :is="cardUrl ? 'a' : 'div'"
    v-bind="cardUrl ? {href: cardUrl, target: '_blank', class: 'card pressable'} : {}"
    @click="clickCard"
  >
    <div class="profile-wall-card">
      <div class="t info-text f-je">{{ shoutout.sent_at }}</div>
      <div v-if="shoutout.fallback_message" class="t ital gray m-tx2">{{ shoutout.fallback_message }}</div>
      <div v-else v-slack-format="shoutout.message" class="t message-text m-tx2" />
      <donut-slack-reactions
        class="m-vx1"
        :reactions="shoutout.reactions"
        :show-add-button="false"
      />
      <div class="f-sb m-tx2">
        <div class="t info-text">{{ attribution }}</div>
        <i v-if="cardUrl" v-tooltip="'View message in Slack'" class="mi md-20 border">open_in_new</i>
      </div>
      <ul v-if="tags">
        <li v-for="tag in tags" :key="tag.hashtagText" v-tooltip="tag.description" class="tag">
          {{ tag.hashtagText }}
        </li>
      </ul>
    </div>
  </component>
</template>

<script setup>
  import { computed } from 'vue';

  const props = defineProps({
    shoutout: { type: Object, required: true },
    program: { type: Object, default: null },
    isForCurrentUser: { type: Boolean, required: true },
  });

  const attribution = computed(() => {
    if (props.shoutout.is_private) {
      return `From ${props.shoutout.message_sender_name} via DM`;
    }
    return props.shoutout.message_sender_name;
  });

  const cardUrl = computed(() => {
    if (!props.shoutout.is_private || (props.shoutout.is_private && props.isForCurrentUser)) {
      return props.shoutout.slack_redirect_path;
    }
  });

  const clickCard = () => {
    if (cardUrl.value) {
 window.donut.track('Shoutouts Wall - Clicked Card', {
      card_type: props.shoutout.is_private ? 'private' : 'public',
      shoutout_id: props.shoutout.id,
    });
}
  };

  const tags = props.shoutout.tags?.map(
    ({ hashtag, description }) => ({
      hashtagText: `#${hashtag}`,
      description,
    }),
  );
</script>

<style scoped lang="scss">
  @import '../../../styles/donut';

  :deep(highlight.current-user) {
    background-color: $slack-yellow;
    border-radius: 3px;
    padding: 2px;
    color: $slack-blue !important;
  }

  .card {
    border-radius: 8px !important;
    border: none !important;
  }

  .profile-wall-card {
    width: 280px;
    border-radius: 8px;
    padding: 24px;
    .info-text { color: $gray }
    .message-text { color: $black }
    border: 2px solid $border;
  }
  .tag {
    display: inline;
    color: $gray;

    &:not(:last-child)::after {
      content: ", ";
    }
  }
</style>
